import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MicroempresarioService } from '../../services/microempresario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { PersonaNatural } from '../../models/persona-natural';
import { AlertService } from 'src/app/services/alert.service';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { NumeroDocumentoService } from '../../services/numero-documento.service';
import { Localidad } from 'src/app/comun/models/localidad';
import { LOCALIDADES_BOGOTA } from 'src/app/comun/data/localidades-bogota';
import {
  numeroDocumentoPorTipoDocValidator,
  getDocumentPatternMessage,
} from 'src/app/shared/utils/form-validators.util';
import { formatPesosCop, parsePesosCop } from 'src/app/shared/utils/currency-cop.util';
import { Constantes } from 'src/app/comun/data/constantes';
//jQuery
declare var $: any;

@Component({
    selector: 'actualizar-persona-natural',
    templateUrl: './actualizar-persona-natural.html',
    providers: [TitleCasePipe],
    standalone: false
})
export class ActualizarPersonaNatural implements OnInit {
  //Selects
  generos: any[];
  documentos: any[];
  ciius: any[] = [];
  anios: any[];
  departamentos: any[] = [];
  ciudades: any[] = [];
  listaTiposCont: any[];

  fuentesInformacion:any[];
  isReferido:boolean=false;
  isOtraFuente:boolean=false;
  paises:any[]=[];
  ventasMinimas:number=0;
  msjErrorValorVentas:string=null;
  isPasaporte: boolean = false;
  idPaisOrigenActual: number;
  titleModal: string = 'R';
  isAutorizarDatos: boolean = false;
  readonly idBogota = 11001;
  private static readonly PAR_DOMINIOS_CORREO_BLOQUEADOS = 'PAR-160';
  /** Lista de dominios de correo no permitidos (PAR-160), cargada desde el back. */
  dominiosCorreoBloqueados: string[] = [];
  localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
  currentStep = 1;
  private readonly step1Fields: string[] = [
    'primerNombre',
    'primerApellido',
    'idTipoDocIdentidad',
    'numeroDocumento',
    'confirmNumeroDocumento',
    'idGenero',
    'numeroCelular',
  ];
  private readonly step2Fields: string[] = [
    'tieneRUT',
    'idDepartamento',
    'idCiudad',
    'codigoCiiu',
    'anioVentas',
    'valorVentas',
    'tiposContacto',
    'correoElectronico',
    'idFuenteNeocredito',
    'camaraComercioVigente',
  ];
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly _microempresario: MicroempresarioService,
    private readonly _parametro: ParametrosService,
    private readonly _alert: AlertService,
    private readonly route: Router,
    private readonly _sweetAlert:SweetAlertService,
    public title: TitleCasePipe,
    private readonly _bancoldexService: BancoldexService,
    private readonly _numeroDocumento: NumeroDocumentoService
  ) { 
    this.getPaises();
  }

  public naturalForm = this.formBuilder.group({
    idEmpresario: null,
    idEmpresarioNatural: null,
    idUsuario: null,
    primerNombre: ['', Validators.required],
    segundoNombre: [''],
    primerApellido: ['', Validators.required],
    segundoApellido: [''],
    idGenero: ['', Validators.required],
    idTipoDocIdentidad: ['', Validators.required],
    idTipoEntidad_NeoTipoEntidad: ['', Validators.required],
    idDepartamento: ['', [ Validators.required,Validators.min(1)]],
    idCiudad: ['', [ Validators.required,Validators.min(1)]],
    idLocalidad: [''],
    numeroDocumento: [
      '',
      [
        Validators.required,
        numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
      ],
    ],
    confirmNumeroDocumento: [
      null,
      [
        Validators.required,
        numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
      ],
    ],
    numeroCelular: ['', Validators.required],
    codigoCiiu: ['', Validators.required],
    correoElectronico: [
      '',
      [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,4}$'),
      ],
    ],
    anioVentas: ['', Validators.required],
    valorVentas: ['', Validators.required],
    ciiuNombre: '',
    tieneRUT: ['', Validators.required],
    minoria: ['', Validators.required],
    minoriaDescripcion: '',
    idFuenteNeocredito: ['', Validators.required],
    nombreReferido: [''],
    codigoReferido: [''],
    otraFuente: [''],
    numeroOpcional:[''],
    idPaisOrigen:[''],
    tiposContacto: ['', Validators.required],
    camaraComercioVigente: ['', Validators.required],
    tratamientoDatos: [null],
  }, {
    validator: [
      this._numeroDocumento.matchPassword('numeroDocumento', 'confirmNumeroDocumento'),
      this.validarReferidoObligatorio(),
    ],
  });

  ngOnInit() {
    this.getActividades();
    this.getGeneros();
    this.getDocumentos();
    this.setPipeForm();
    this.getAnios();
    this.getDepartamentos();
    this.getParametroValorMinVentas();
    this.getParametroDominiosCorreoBloqueados();
    this.getListaTiposContacto();
    this.naturalForm.get('idTipoDocIdentidad')?.valueChanges?.subscribe(() => {
      this.naturalForm.get('numeroDocumento')?.updateValueAndValidity();
      this.naturalForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    });
    this.naturalForm.get('numeroDocumento')?.valueChanges?.subscribe(() => {
      this.naturalForm.updateValueAndValidity({ emitEvent: false });
    });
    this.naturalForm.get('tieneRUT')?.valueChanges.subscribe((valor: string) => {
      this.naturalForm.get('idFuenteNeocredito')?.setValue('');
      this.isReferido = false;
      this.isOtraFuente = false;
      if (valor) {
        this.getFuentes(valor);
      }
    });
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      this.bindCodigoCiiuWrapText();
      this.loadData();
    }, 1000);
  }

  //Cargar selects
  getGeneros() {
    this._parametro
      .getGeneros()
      .subscribe((data: any) => (this.generos = data));
  }

  getDocumentos() {
    this._parametro.getTipoDocumentos().subscribe((data: any) => {
      if (data) {
        this.documentos = data.filter(
          (documento) =>
            documento.personaJuridica == 0 &&
            documento.idTipoDocIdentidad != 4 &&
            documento.idTipoDocIdentidad != 6
        );
        this.naturalForm.get('numeroDocumento')?.updateValueAndValidity();
        this.naturalForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
      }
    });
  }

  getActividades() {
    this._parametro.getCiius().subscribe((data: any) => {
      this.ciius = data?.data ?? [];
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
        this.bindCodigoCiiuWrapText();
      }, 300);
    });
  }

  getAnios() {
    this._parametro
      .getAnios('natural')
      .subscribe((data: any) => {
        this.anios = data.anios
        this.anios = this.anios.filter(anio => anio != new Date().getFullYear()-2 &&  anio != new Date().getFullYear());
      });
  }

  getDepartamentos() {
    this._parametro
      .getDepartamentos('169')
      .subscribe((data: any) => (this.departamentos = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los departamentos');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getCambio(i){
    this.selectpikerChange('idDepartamento');
    this.naturalForm.get('idCiudad').setValue('');
    $('.selectpicker').selectpicker('refresh');
    if(i.target.value != 0){
      this.getCiudades(i.target.value);
    }else{
      $('#idCiudad').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    }
  }

  getCiudades(idDepartamento: number) {
    this._parametro
      .getCiudades(idDepartamento.toString()).subscribe((data: any) => (this.ciudades = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', false);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getFuentes(valor: string) {
    const filtro = {
      tiposPersona: [
        {
          idTipoPersonaJuridica: valor == Constantes.VALOR_SI
            ? Constantes.TIPO_PERSONA.NATURAL_FORMAL
            : Constantes.TIPO_PERSONA.NATURAL_INFORMAL
        }
      ]
    };
    this._microempresario.getFuentes(filtro).subscribe((response: any) => {
      if (response.exitoso) {
        this.fuentesInformacion = response.fuentes;
      } else {
        this._sweetAlert.errorModal("Error", true, "Error al cargar las fuentes de información")
      }
    },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'Error al cargar las fuentes de información');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        }, 300);
      });
  }

  /** Carga PAR-160 (dominios de correo bloqueados) y aplica validador al campo correo. */
  getParametroDominiosCorreoBloqueados() {
    const json = {
      idParametro: ActualizarPersonaNatural.PAR_DOMINIOS_CORREO_BLOQUEADOS,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const data = response['data'];
        if (data && data[0] && data[0].valorParametro) {
          const valor = String(data[0].valorParametro).trim();
          this.dominiosCorreoBloqueados = valor
            .split(',')
            .map((d: string) => d.trim().toLowerCase())
            .filter((d: string) => d.length > 0);
        }
        this.agregarValidadorDominioCorreo();
      },
      () => {
        this.agregarValidadorDominioCorreo();
      }
    );
  }

  private agregarValidadorDominioCorreo() {
    const control = this.naturalForm.get('correoElectronico');
    if (!control) return;
    const validadores = [
      Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\\.[a-z0-9-]+)*\\.[a-z]{2,4}$'),
      this.dominioCorreoBloqueadoValidator(),
    ];
    control.setValidators(validadores);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private dominioCorreoBloqueadoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || String(value).trim() === '') return null;
      const idx = String(value).lastIndexOf('@');
      if (idx <= 0 || idx === String(value).length - 1) return null;
      const dominio = String(value).substring(idx + 1).trim().toLowerCase();
      if (this.dominiosCorreoBloqueados.length === 0) return null;
      if (this.dominiosCorreoBloqueados.includes(dominio)) {
        return { dominioCorreoBloqueado: true };
      }
      return null;
    };
  }

  /** Mensaje de error para correo electrónico (requerido, formato, dominio bloqueado). */
  getCorreoElectronicoErrorMessage(): string {
    const c = this.naturalForm.get('correoElectronico');
    if (!c?.errors) return '';
    if (c.hasError('required')) return 'Campo obligatorio';
    if (c.hasError('dominioCorreoBloqueado')) {
      return 'No está permitido el uso de correos temporales o de dominios no válidos para el registro.';
    }
    if (c.hasError('pattern')) return 'El correo electrónico no tiene una estructura válida (ej: correo@dominio.com).';
    return 'Correo electrónico no válido';
  }

   getPaises(){
    this._parametro
      .getPaises()
      .subscribe((data: any) => (this.paises = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los paises');
      });
  }

  getParametroValorMinVentas() {
    var json = {
      idParametro: 'PAR-118',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.ventasMinimas = Number(respuesta[0].valorParametro);
        this.validarVentaAnual();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getListaTiposContacto(){
    this._microempresario.getListaTipoContacto().subscribe((resp: any) =>{
      this.listaTiposCont = resp;
    },
    (error) => {
      this._sweetAlert.errorModal("Error!",true,error.error);
    });
  }
  //Fin cargar selects

  loadData() {
    this._microempresario.cargarDatosPersonaNatural().subscribe((data: any) => {
      if (data.microempresario) {
        this.loadFields(data.microempresario);
      }
    });
  }

  loadFields(empresario: any) {
    this.naturalForm.get('idEmpresario').setValue(empresario.idEmpresario);
    this.naturalForm
      .get('idEmpresarioNatural')
      .setValue(empresario.idEmpresarioNatural);
    this.naturalForm.get('idUsuario').setValue(empresario.idUsuario);
    this.naturalForm.get('primerNombre').setValue(empresario.primerNombre);
    this.naturalForm.get('segundoNombre').setValue(empresario.segundoNombre);
    this.naturalForm.get('primerApellido').setValue(empresario.primerApellido);
    this.naturalForm
      .get('segundoApellido')
      .setValue(empresario.segundoApellido);
    this.naturalForm.get('idGenero').setValue(empresario.idGenero);
    this.naturalForm.get('numeroCelular').setValue(empresario.numeroCelular);
    if (empresario.idDepartamento != null && empresario.idDepartamento != 0) {
      this.naturalForm.get('idDepartamento').setValue(empresario.idDepartamento);
      $('#idDepartamento').selectpicker('val', Number(empresario.idDepartamento));
      this.getCiudades(empresario.idDepartamento);
      this.naturalForm.get('idCiudad').setValue(empresario.idCiudad);
      $('#idCiudad').selectpicker('val', Number(empresario.idCiudad));
      if (empresario.idCiudad == this.idBogota && empresario.idLocalidad != null) {
        this.naturalForm.get('idLocalidad').setValue(empresario.idLocalidad);
        $('#idLocalidad').selectpicker('val', Number(empresario.idLocalidad));
      } else {
        this.naturalForm.get('idLocalidad').setValue(null);
      }
      this.validarLocalidad();
    }
    this.naturalForm.get('tiposContacto').setValue(empresario.tiposContacto);
    this.naturalForm.get('codigoCiiu').setValue(empresario.codigoCiiu);
    const anioGuardado = Number(empresario.anioVentas);
    // Solo enriquecer catálogo con años reales ya guardados (no 0 / vacíos)
    if (anioGuardado > 0 && !this.anios.includes(anioGuardado)) {
      this.anios.push(anioGuardado);
    }
    this.naturalForm
      .get('anioVentas')
      .patchValue(anioGuardado > 0 ? anioGuardado : '');
    this.naturalForm
      .get('numeroDocumento')
      .setValue(empresario.numeroDocumento);
    this.naturalForm
      .get('idTipoDocIdentidad')
      .setValue(empresario.idTipoDocIdentidad);
    this.naturalForm.get('valorVentas').setValue(formatPesosCop(empresario.valorVentas));
    this.naturalForm
      .get('correoElectronico')
      .setValue(empresario.correoElectronico);
    this.naturalForm
      .get('idTipoEntidad_NeoTipoEntidad')
      .setValue(empresario.idTipoEntidad_NeoTipoEntidad);
    this.naturalForm.get('tieneRUT').setValue(empresario.tieneRUT);
    this.naturalForm.get('minoria').setValue(empresario.minoria);
    this.naturalForm.get('minoriaDescripcion').setValue(empresario.minoriaDescripcion);
    this.validarMinoria(empresario.minoria);
    this.naturalForm.get('codigoReferido').setValue(empresario.codigoReferido);
    this.naturalForm.get('idFuenteNeocredito').setValue(empresario.idFuenteNeocredito);
    this.valueSelected(empresario.idFuenteNeocredito);
    this.naturalForm.get('nombreReferido').setValue(empresario.nombreReferido);
    this.naturalForm.get('otraFuente').setValue(empresario.otraFuente);
    this.naturalForm.get('numeroOpcional').setValue(empresario.numeroOpcional);
    this.naturalForm.get('idPaisOrigen').setValue(empresario.idPaisOrigen);
    this.naturalForm.get('camaraComercioVigente').setValue(empresario.camaraComercioVigente);
    this.idPaisOrigenActual = empresario.idPaisOrigen;
    // Tras cargar tipo doc (p. ej. pasaporte): mostrar nacionalidad sin limpiar documentos
    this.actualizarVisibilidadNacionalidad(false);
    this.validarVentaAnual();
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      this.bindCodigoCiiuWrapText();
      this.validateForm();
    }, 1000);
  }

  submit() {
    const json: PersonaNatural = this.naturalForm.value;
    // Backend exige tratamientoDatos no nulo. Si null (checkbox no mostrado), enviar false para no actualizar fecha en BD
    json.tratamientoDatos = json.tratamientoDatos ?? false;
    json.valorVentas = parsePesosCop(this.naturalForm.get('valorVentas').value);
    json.ciiuNombre = this.ciius.find(
      (c) => c.codigoCiiu == this.naturalForm.get('codigoCiiu').value
    ).nombreCiiu;
    json.numeroDocumento = json.numeroDocumento.toLocaleUpperCase().trim();
    json.correoElectronico = json.correoElectronico.toLowerCase().trim();
    json.primerNombre = json.primerNombre.trim();
    if (json.segundoNombre != null && json.segundoNombre != '') {
      json.segundoNombre = json.segundoNombre.trim();
    }
    json.primerApellido = json.primerApellido.trim();
    if (json.segundoApellido != null && json.segundoApellido != '') {
      json.segundoApellido = json.segundoApellido.trim();
    }
    json.idFuenteNeocredito = Number(json.idFuenteNeocredito);
    json.idLocalidad = json.idLocalidad ? json.idLocalidad : null;
    this._microempresario.updatePersonaNatural(json).subscribe({
      next: (data: any) => {
        if (data?.faltaInfo) {
          this._sweetAlert.infoModal('Información', true, data.advertencia || 'Hay campos obligatorios sin diligenciar');
          return;
        }
        if (data.exitoso === true) {
          this._sweetAlert.successModal(data.mensaje);
          this.route.navigate(['microempresario/home']);
        } else {
          this._sweetAlert.errorModal('Error!', true, data.error);
        }
      },
      error: (err) => {
        const msg = typeof err === 'string' ? err : 'Error al actualizar los datos';
        this._sweetAlert.errorModal('Error!', true, msg);
      },
    });
  }
  //Validaciones
  validateField(key: string) {
    return (
      (this.naturalForm.get(key).dirty || this.naturalForm.get(key)?.touched) &&
      this.naturalForm.get(key)?.invalid
    );
  }

  /** Mensaje de error para número de documento según tipo (CC/CE/PA). */
  getDocumentPatternMessage(controlName: string): string {
    const control = this.naturalForm.get(controlName);
    return getDocumentPatternMessage(control);
  }

  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (
      this.naturalForm.get('idTipoDocIdentidad').value == 5 ||
      this.naturalForm.get('idTipoDocIdentidad').value == 3
    ) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.naturalForm.get('numeroDocumento').setValue('');
    this.naturalForm.get('confirmNumeroDocumento').setValue(null);
    this.naturalForm.get('numeroDocumento')?.updateValueAndValidity();
    this.naturalForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    this.actualizarVisibilidadNacionalidad(true);
  }

  /**
   * Nacionalidad visible y requerida si el tipo de doc no es CC (id 2).
   * Aplica a CE, pasaporte, etc. `resetPaisSiCc` solo al cambiar el select (no al cargar datos).
   */
  private actualizarVisibilidadNacionalidad(resetPaisSiCc: boolean): void {
    const tipo = this.naturalForm.get('idTipoDocIdentidad')?.value;
    const requierePais = tipo != null && tipo !== '' && Number(tipo) !== 2;
    this.isPasaporte = requierePais;
    if (requierePais) {
      this.setearValidadoresForm('idPaisOrigen', [Validators.required]);
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
    } else {
      this.setearValidadoresForm('idPaisOrigen', null);
      if (resetPaisSiCc) {
        this.naturalForm.get('idPaisOrigen').setValue(this.idPaisOrigenActual);
      }
    }
  }

  setPipeForm() {
    this.naturalForm.controls['valorVentas'].valueChanges.subscribe((data) => {
      if (data == null || data === '') {
        return;
      }
      this.naturalForm.patchValue(
        { valorVentas: formatPesosCop(data) },
        { emitEvent: false }
      );
    });
  }

  validateForm() {
    let fuente = this.naturalForm.get('idFuenteNeocredito').value;
    let nombreReferido = this.naturalForm.get('nombreReferido').value;
    let codigoReferido = this.naturalForm.get('codigoReferido').value;
    if (this.naturalForm.valid) {
      if(fuente=='7'){            
        if((nombreReferido != '' && nombreReferido != null) || (codigoReferido != '' && codigoReferido != null)){
          this.naturalForm.get('otraFuente').setValue('');
          this.submit();
        }else{
          this._sweetAlert.infoModal("Información",true,"Debe registrar por lo menos uno de los dos campos, ¿Quién te refirió? ó El código del referido")
          this.naturalForm.get('otraFuente').setValue('');
        }
      }else if(fuente=='8'){
        this.naturalForm.get('nombreReferido').setValue('');
        this.naturalForm.get('codigoReferido').setValue('');
        this.submit();
      }if(fuente!='7' && fuente!='8'){
        this.naturalForm.get('nombreReferido').setValue('');
        this.naturalForm.get('codigoReferido').setValue('');
        this.naturalForm.get('otraFuente').setValue('');
        this.submit();
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'Diligencia correctamente los campos obligatorios antes de continuar la actualización de datos.');
      this.naturalForm.markAllAsTouched();
      this.selectpikerChange('codigoCiiu');
      this.selectpikerChange('idDepartamento');
      this.selectpikerChange('idCiudad');
      this.selectpikerChange('idFuenteNeocredito');
      this.selectpikerChange('idPaisOrigen');
      this.selectpikerChange('tiposContacto');
      this.selectpikerChange('idLocalidad');
    }
  }

  selectpikerChange(field: string) {
    $(`#${field}`).selectpicker('destroy');
    let valid = this.validateField(field);
    if (!valid) {
      $(`#${field}`).removeClass('is-invalid');
    } else {
      $(`#${field}`).addClass('is-invalid');
    }
    $(`#${field}`).addClass('selectpicker');
    $(`#${field}`).selectpicker('render');
    if (field === 'codigoCiiu') {
      this.bindCodigoCiiuWrapText();
    }
  }

  /** Actividad económica: opciones largas en varias líneas (sin scroll horizontal). */
  private bindCodigoCiiuWrapText(): void {
    const $el = $('#codigoCiiu');
    if (!$el?.length || typeof $el.selectpicker !== 'function') {
      return;
    }
    $el
      .off('shown.bs.select.actividadWrap')
      .on('shown.bs.select.actividadWrap', () =>
        this.styleSelectpickerWrapText($el)
      );
    this.styleSelectpickerWrapText($el);
  }

  private styleSelectpickerWrapText($el: any): void {
    const picker = $el.data('selectpicker');
    if (!picker?.$menu?.length) {
      return;
    }
    const btnWidth = picker.$newElement?.outerWidth?.() || $el.outerWidth();
    const $menu = picker.$menu;
    $menu.addClass('selectpicker-wrap-text-dropdown');
    if (btnWidth) {
      $menu[0].style.setProperty('--selectpicker-wrap-width', `${btnWidth}px`);
      $menu[0].style.setProperty('overflow-x', 'hidden', 'important');
    }
    $menu.find('.inner').css({
      overflowX: 'hidden',
      overflowY: 'auto',
      maxWidth: '100%',
    });
    $menu.find('li a, li a span.text').css({
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
      maxWidth: '100%',
      display: 'block',
    });
  }

  validarMinoria(numero:number) {
    if (numero == 1) {
      this.setearValidadoresForm('minoriaDescripcion', [
        Validators.required,
      ]);
    } else {
      this.setearValidadoresForm('minoriaDescripcion', null);
      this.naturalForm.get('minoriaDescripcion').setValue('');
    }
  }

  onCiudadChange() {
    this.selectpikerChange('idCiudad');
    this.validarLocalidad();
  }

  validarLocalidad() {
    if (this.naturalForm.get('idCiudad').value == this.idBogota) {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      this.setearValidadoresForm('idLocalidad', [Validators.required])
    } else {
      this.setearValidadoresForm('idLocalidad', null)
      this.naturalForm.get('idLocalidad').setValue(null);
    }
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.naturalForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.naturalForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  validarTexto(e){
    e.target.value = this.title.transform(e.target.value);
  }

  valueSelected(valueId:any){
    this.selectpikerChange('idFuenteNeocredito');
    if(valueId == '7'){
      this.isReferido=true;
      this.isOtraFuente=false;
      this._sweetAlert.infoModal('Información', true, 'Debe registrar por lo menos uno de los dos campos, ¿Quién te refirió? ó El código del referido');
      this.setearValidadoresForm('otraFuente', null);
    }else if(valueId == '8'){
      this.isOtraFuente=true;
      this.isReferido=false;
      this.setearValidadoresForm('otraFuente',[Validators.required]);
    }else{
      this.isReferido=false;
      this.isOtraFuente=false;
      this.setearValidadoresForm('otraFuente', null);
    }
    this.naturalForm.updateValueAndValidity();
  }

  private validarReferidoObligatorio(): (control: AbstractControl) => ValidationErrors | null {
    return (group: AbstractControl): ValidationErrors | null => {
      const idFuente = group.get?.('idFuenteNeocredito')?.value;
      const nombre = (group.get?.('nombreReferido')?.value ?? '').toString().trim();
      const codigo = (group.get?.('codigoReferido')?.value ?? '').toString().trim();
      const nomControl = group.get?.('nombreReferido');
      if (idFuente === '7' || idFuente === 7) {
        if (!nombre && !codigo) {
          nomControl?.setErrors({ ...nomControl?.errors, referidoRequired: true });
          return { referidoRequired: true };
        }
      }
      if (nomControl?.errors?.['referidoRequired']) {
        const err = { ...nomControl.errors };
        delete err['referidoRequired'];
        nomControl.setErrors(Object.keys(err).length ? err : null);
      }
      return null;
    };
  }

  validarVentaAnual(){
    const ventaMinima = formatPesosCop(this.ventasMinimas);
    if (this.naturalForm.get('valorVentas').value) {
      if (parsePesosCop(this.naturalForm.get('valorVentas').value) < this.ventasMinimas) {
        this.naturalForm.get('valorVentas').setErrors({ incorrect: true });
        this.msjErrorValorVentas = "Campo obligatorio. El monto mínimo es de " + ventaMinima + " pesos.";
      }
    }else{
      this.msjErrorValorVentas = "Campo obligatorio";
    }
  }

  selectpikerChangeContactos(field: string) {
    let valid = this.validateField(field);
    const tiposContactoElement = document.getElementById('tiposContacto');
    if (valid) {
      tiposContactoElement.classList.add('is-invalid');
    } else {
      if (tiposContactoElement.classList.contains('is-invalid')) {
        $(`#${field}`).selectpicker('destroy');
      }
      tiposContactoElement.classList.remove('is-invalid');
    }
    $(`#${field}`).selectpicker('refresh');
  }

  autorizarDatos(){
    this.setearValidadoresForm('tratamientoDatos', [
      Validators.required, Validators.requiredTrue
    ]);
    this.isAutorizarDatos = true;
  }

  showModal(title: string) {
    this.titleModal = title;
  }

  goToNextStep() {
    this.markFieldsAsTouched(this.step1Fields);
    this.markConditionalFieldsTouchedStep1();
    if (this.isStep1Valid()) {
      if (this.naturalForm.get('idCiudad').value === '') {
        $('#idCiudad').prop('disabled', true);
      }
      this.currentStep = 2;
      // codigoCiiu solo existe en paso 2 (@if): hay que enlazar wrap tras pintar el DOM
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
        this.bindCodigoCiiuWrapText();
      }, 300);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this._sweetAlert.errorModal(
        'Error!',
        true,
        'Diligencia correctamente los campos obligatorios de Información general antes de continuar.'
      );
    }
  }

  goToPreviousStep() {
    if (this.currentStep === 1) {
      this.route.navigate(['microempresario/home']);
      return;
    }
    this.currentStep = 1;
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 300);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  isStep1Valid(): boolean {
    const baseValid = this.step1Fields.every((field) => this.naturalForm.get(field)?.valid);
    if (!baseValid) return false;
    if (this.isPasaporte && !this.naturalForm.get('idPaisOrigen')?.valid) return false;
    // Si respondió que sí pertenece a una minoría, debe indicar cuál para poder continuar
    if (this.naturalForm.get('minoria')?.value === 1 && !this.naturalForm.get('minoriaDescripcion')?.valid) return false;
    return true;
  }

  isStep2Ready(): boolean {
    const baseValid = this.step2Fields.every((field) => this.naturalForm.get(field)?.valid);
    if (!baseValid) return false;
    if (this.naturalForm.get('idCiudad')?.value === this.idBogota && !this.naturalForm.get('idLocalidad')?.valid) return false;
    if (this.naturalForm.get('minoria')?.value === 1 && !this.naturalForm.get('minoriaDescripcion')?.valid) return false;
    if (this.isReferido) {
      const nom = (this.naturalForm.get('nombreReferido')?.value ?? '').toString().trim();
      const cod = (this.naturalForm.get('codigoReferido')?.value ?? '').toString().trim();
      if (!nom && !cod) return false;
    }
    if (this.isOtraFuente && !this.naturalForm.get('otraFuente')?.valid) return false;
    if (this.isAutorizarDatos && !this.naturalForm.get('tratamientoDatos')?.valid) return false;
    return true;
  }

  private markFieldsAsTouched(fields: string[]) {
    fields.forEach((field) => {
      const control = this.naturalForm.get(field);
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private markConditionalFieldsTouchedStep1() {
    if (this.isPasaporte) {
      this.naturalForm.get('idPaisOrigen')?.markAsTouched();
      this.naturalForm.get('idPaisOrigen')?.updateValueAndValidity();
    }
  }
}
